import { useState, useEffect } from 'react';
import axios from 'axios';
import { load } from '@cashfreepayments/cashfree-js';

function App() {
  let cashfree;

  // Initialize Cashfree SDK
  let initializeSDK = async () => {
    cashfree = await load({
      mode: "sandbox", // Use 'production' mode in production environment
    });
  };

  useEffect(() => {
    initializeSDK();
  }, []);

  const [orderId, setOrderId] = useState("");
  const [customerDetails, setCustomerDetails] = useState({
    name: "",
    email: "",
    phone: "",
    amount: 1.00,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Get session ID from backend (this will trigger payment session creation)
  const getSessionId = async () => {
    try {
      let res = await axios.post("https://api.aptapace.com/submit-orders", customerDetails);
      if (res.data && res.data.payment_session_id) {
        setOrderId(res.data.order_id); // Set the orderId for payment verification
        return res.data.payment_session_id;
      }
    } catch (error) {
      console.warn("Error getting session ID:", error);
    }
  };

  // Verify payment status after checkout
  const verifyPayment = async () => {
    try {
      let res = await axios.post("https://api.aptapace.com//verify", { orderId: orderId });
      if (res && res.data) {
        alert("Payment verified");
      }
    } catch (error) {
      console.error("Error verifying payment:", error);
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      let sessionId = await getSessionId();

      const checkoutOptions = {
        paymentSessionId: sessionId,
        redirectTarget: "_modal",
      };

      cashfree.checkout(checkoutOptions).then((res) => {
        verifyPayment();
      }).catch((err) => {
        console.error("Error during payment:", err);
      });
    } catch (error) {
      console.error("Error during payment process:", error);
    }
  };

  return (
    <>
      <h1>Cashfree Payment Gateway</h1>
      <div className="card">
        <input
          type="text"
          name="name"
          value={customerDetails.name}
          onChange={handleInputChange}
          placeholder="Customer Name"
        />
        <input
          type="email"
          name="email"
          value={customerDetails.email}
          onChange={handleInputChange}
          placeholder="Customer Email"
        />
        <input
          type="text"
          name="phone"
          value={customerDetails.phone}
          onChange={handleInputChange}
          placeholder="Customer Phone"
        />
        <input
          type="number"
          name="amount"
          value={customerDetails.amount}
          onChange={handleInputChange}
          placeholder="Amount"
        />
        <button onClick={handleClick}>Pay Now</button>
      </div>
    </>
  );
}

export default App;
